module.exports = __webpack_public_path__ + "img/product-icon6.7d95bdfe.png";